import { Staff } from "types";
import { TransformedStaff } from "./types";

export const changeStaffID = (staff: Staff[]) => {
  return staff.map((item) => ({
    ...item,
    id: item.id.toString(),
  })) as TransformedStaff[];
};
